module.exports = __webpack_public_path__ + "img/supermarket_basket.c656a5a7.png";